
module.exports = function DateInput ($host, config) {

  // Dom

  var $any   = $('[data-date-part]',         $host);
  var $day   = $('[data-date-part="day"]',   $host);
  var $month = $('[data-date-part="month"]', $host);
  var $year  = $('[data-date-part="year"]',  $host);
  var $value = $('input[type="hidden"]',     $host);


  // Functions

  function formatDate (year, month, day) {
    return [ year, padTwo(parseInt(month)), padTwo(parseInt(day)) ].join('-');
  }

  function updateValue () {
    var lastday = new Date($year.val(), $month.val(), 0).getDate();
    if ( $day.val() > lastday ) {
      $day.val(lastday);
    }    
    $value.val(formatDate( $year.val(), $month.val(), $day.val() ));
  }


  // Listeners

  $any.on('change', updateValue);


  // Init

  updateValue();

};

